import './SensorDetails.css';
import React from 'react'
import { withRouter } from 'react-router-dom'
import SensorDataDisplay from '../../Components/SensorDataDisplay/SensorDataDisplay';
import LineChart from '../../Components/LineChart/LineChart';
import SensorDataProvider from '../../Services/SensorDataProvider';
import containerWithResizeDetector from '../../Components/ContainerWithResizeDetector/ContainerWithResizeDetector';
import SensorReader from '../../Communication/SensorReader';

const LineChartWithResize = containerWithResizeDetector(LineChart);

const LIVE_TIMEOUT = 8000;

class SensorDetails extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			currentSensorId: props.isRootForcedFurnace ? 0 : SensorDetails.getSensorId(props.match),
			live: false,
			currentSensorData: null,
			historicData: []
		}

		this.liveTimer = null;
		this.fetchData = this.fetchData.bind(this);

		window.SD = this;
	}

	componentDidMount() {
		console.log('Sensor details did mount')
		this.unregisterSensorListener = SensorReader.registerListener({
			onMessage: this.onGetCurrentSensorData.bind(this),
			onDeath: this.onConnectionDeath.bind(this)
		})
		this.fetchData();
	}

	componentWillUnmount() {
		this.unregisterSensorListener();
	}


	onGetCurrentSensorData(sensorData) {
		if (sensorData.sensorId === this.state.currentSensorId) {
			this.setState({
				currentSensorData: sensorData,
				live: true
			});

			clearTimeout(this.liveTimer);
			this.liveTimer = setTimeout(() => {
				this.setState({ live: false })
			}, LIVE_TIMEOUT);
		}
	}

	onConnectionDeath() {
		console.log('on death handler')
		this.setState({live: false})
	}

	static getSensorId(match) {
		return Number(match.params.id)
	}

	static getDerivedStateFromProps(props, state) {
		const newSensorId = SensorDetails.getSensorId(props.match)

    if (!props.isRootForcedFurnace && newSensorId !== state.currentSensorId) {
      return {
        currentSensorId: newSensorId
      };
		}
		
    return null;
	}

	async fetchData() {
		const _tmpFirstOfMarch = (new Date(2021,2,2)).toISOString();
		const threeDaysBefore = (new Date((new Date()).getTime() - (3 * 24 * 60 * 60 * 1000))).toISOString();
		const todayUTC = (new Date()).toISOString();
		const data = await SensorDataProvider.getData({
			startDate: threeDaysBefore,
			endDate: todayUTC,
			sensorId: 0, //TMP lock for only available sensor
		});

		this.setState({historicData: data})
	}

	render() {
		const {
			temp,
			ppm,
			rh
		} = this.state.currentSensorData || {};

		return (
			<div className="sensor-details">
				<SensorDataDisplay temp={temp} rh={rh} ppm={ppm} live={this.state.live}/>
				<LineChartWithResize data={this.state.historicData}/>
			</div>
		)
	}
}

SensorDetails.defaultProps = {
	isRootForcedFurnace: false // root url is a furnace sensor details
}

export default withRouter(SensorDetails);